import agentApiService from "../../../../services/travel/listing/agentApiService";

export const fetchQuoteList = async (payload: { productType: string }) => {
  const data = await agentApiService.getQuoteList(payload);
  return data;
};
